// src/hooks/useAuth.js
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

// 📌 Custom hook useAuth: Dùng để lấy thông tin user từ Cookie hoặc từ token
export const useAuth = () => {
    // 📌 user: lưu thông tin người dùng hiện tại
    const [user, setUser] = useState(null);

    // 📌 useEffect chạy khi component sử dụng hook này được render lần đầu
    useEffect(() => {
        const storedUser = Cookies.get("user");
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
                return;
            } catch (err) {
                console.error("Error parsing user cookie:", err);
            }
        }

        // 🔍 Nếu không có user cookie, thử lấy từ accessToken
        const token = Cookies.get("accessToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUser(decoded);
            } catch (err) {
                console.error("Invalid token:", err);
                setUser(null);
            }
        } else {
            setUser(null);
        }
    }, []);

    // 📌 Trả về object chứa thông tin user để các component khác dùng
    return { user };
};
